import { render, staticRenderFns } from "./app-secret.vue?vue&type=template&id=2ac04400&scoped=true&"
import script from "./app-secret.vue?vue&type=script&lang=ts&"
export * from "./app-secret.vue?vue&type=script&lang=ts&"
import style0 from "./app-secret.vue?vue&type=style&index=0&id=2ac04400&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac04400",
  null
  
)

export default component.exports